var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUploadimg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4314 28.0001L11.1982 18.0001C11.8493 17.3335 13.5422 16.4001 15.1049 18.0001C16.6675 19.6001 22.2672 25.3335 24.8716 28.0001",
    stroke: "#8D95A1",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4534 23.5L25.1973 19.7306C25.7399 19.1793 27.1506 18.4074 28.4529 19.7306C29.7551 21.0537 30.5148 21.2948 32.6851 23.5",
    stroke: "#8D95A1",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7783 4H36.5917",
    stroke: "#8D95A1",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6851 8L32.6851 0",
    stroke: "#8D95A1",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 4H7.4314C4.11769 4 1.4314 6.68629 1.4314 10V30C1.4314 33.3137 4.11768 36 7.43139 36H26.685C29.9988 36 32.685 33.3137 32.685 30V15.2941",
    stroke: "#8D95A1",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.9883,
    y: 11,
    width: 1.95335,
    height: 2,
    fill: "#8D95A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadimg);
export default __webpack_public_path__ + "static/media/icon-uploadimg.6b47d672.svg";
export { ForwardRef as ReactComponent };